<button mat-stroked-button 
    (click)="clickButton()" 
    *ngIf="asButton"
    [disabled]="disabled"
    title="{{ '' | translate:['tmc-yard.widgets.sac-client.station-transport-details.action.show-details', translationService.language]}}">
    <mat-icon><sc-icon iconClass="fa-info"></sc-icon></mat-icon>
</button>
<button mat-icon-button 
    (click)="clickButton()" 
    *ngIf="!asButton"
    [disabled]="disabled"
    title="{{ '' | translate:['tmc-yard.widgets.sac-client.station-transport-details.action.show-details', translationService.language]}}">
    <mat-icon><sc-icon iconClass="fa-info"></sc-icon></mat-icon>
</button>